<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <span class="back" @click="$router.go(-1)"><i class="el-icon-back"></i>&nbsp;&nbsp;&nbsp;&nbsp;返回</span>
            <div class="form">
                <el-form
                    :model="form"
                    :rules="applyrules"
                    ref="applyForm"
                    label-width="100px"
                    class="demo-ruleForm"
                >
                    <el-form-item
                        label="认证账号"
                        label-width="140px"
                        prop="loginName"
                    >
                        <span style="color:cornflowerblue">{{$getlocalStorage("userData").loginName}}</span>
                    </el-form-item>
                    <el-form-item
                        label="姓名"
                        label-width="140px"
                        prop="legalName"
                    >
                        <el-input
                            :disabled="inputStatus==0"
                            v-model="form.legalName"
                            placeholder="请输入法人姓名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        v-if="inputStatus==0"
                        label="身份证号码"
                        label-width="140px"
                        prop="idCardHidden"
                    >
                        <el-input
                            v-model="form.idCardHidden"
                            :disabled="inputStatus==0"
                            placeholder="请输入法人身份证号码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        v-else
                        label="身份证号码"
                        label-width="140px"
                        prop="idCard"
                    >
                        <el-input
                            v-model="form.idCard"
                            placeholder="请输入法人身份证号码"
                        ></el-input>
                    </el-form-item>

                    <el-form-item
                        label="手机号码"
                        label-width="140px"
                        prop="phone"
                    >
                        <el-input
                           v-model="form.phone"
                            placeholder="请输入手机号码"
                        ></el-input>
                    </el-form-item>
                    
                    <div class="yzm-item">
                        <el-form-item
                            label="验证码:"
                            label-width="130px"
                            prop="code"
                        >
                            <el-input
                                v-model="form.code"
                                placeholder="短信验证码"
                            ></el-input>
                        </el-form-item>
                        <span
                            :disabled="disabled"
                            @click="getVerificationCode"
                            >{{ yzmtext }}</span
                        >
                    </div>
                    
                    <div class="submit">
                        <span @click="onSubmit('applyForm')">提交</span>
                    </div>
                </el-form>
            </div>
        </div>
        <div id="captcha-element"></div>
    </el-row>
</template>

<script>
import {entLegalInfo,sendMsg,updateEntInfo} from "@http/user_center/realName";
import NoTrace from '@/utils/noTrace';
var interval = null;
export default {
    data() {
        var vphone = (rule, value, callback) => {
            if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error("手机号格式不正确"));
            }
            callback();
        };
        return {
            form:{
                loginName:'',
                legalName:'',
                idCard:'',
                idCardHidden:'',
                phone:'',
                code:'',
            },
            applyrules: {
                legalName: [
                    {
                        required: true,
                        message: "请输入法人姓名",
                        trigger: "blur",
                    },
                ],
                idCardHidden:[
                    {
                        required: true,
                        message: "请输入法人身份证号码",
                        trigger: "blur",
                    },
                ],
                idCard: [
                    {
                        required: true,
                        message: "请输入法人身份证号码",
                        trigger: "blur",
                    },
                ],
                phone:[
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur",
                    },
                    { validator: vphone, trigger: "blur" },
                ],
                code:[
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur",
                    },
                ],
            },
            yzmtext: "获取验证码",
            disabled: false,
            currentTime: 60,
            nvc:'',
            inputStatus:'',
            
        };
    },

    components: {},

    computed: {},

    async created() {
        let res=await entLegalInfo();
        this.inputStatus=res.inputStatus;
        if(res.entStatus==2){
            // 个人认证
            this.form.loginName=this.$getlocalStorage('userData')?.loginName
        }else{
            // 企业法人认证
            this.form=Object.assign({}, this.form, res);
        }
    },

    mounted() {
        NoTrace.init('captcha-element', 'captcha-button')
    },
    beforeDestroy() {
        NoTrace.reset()
    },

    methods: {
        async getVerificationCode() {
            var that = this;
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35022,
                    "logParam":{
                        'phone':that.form.phone
                    }
                },
            });
            let { phone } = that.form;
            if (!phone) {
                that.$msg("联系人手机号不能为空");
                return false;
            }
            let reg = /^1[3456789]\d{9}$/;
            if (!reg.test(phone)) {
                that.$msg("手机号格式不正确");
                return false;
            }
            this.getCode();
            that.disabled = true;

            // 开始获取无痕验证码
            NoTrace.start((nvc) => {
                this.nvc = nvc
            }, this.executeFun, {
                phone: that.form.phone,
                nvc: '',
                afsVersion: 2
            })
        },
        executeFun (params) {
            let that=this;
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await sendMsg(params);
                    resolve(res)
                    that.$msg(res.message, "success");
                }catch (err) {
                    reject(err)
                    that.$msg('发送失败')
                    clearInterval(interval);
                    that.yzmtext = "获取验证码";
                    that.disabled = false;
                }
            })
        },
        getCode() {
            var that = this;
            var currentTime = that.currentTime;
            interval = setInterval(function() {
                currentTime--;
                that.yzmtext = "(" + currentTime + "s)重新获取";
                if (currentTime <= 0) {
                    clearInterval(interval);
                    that.yzmtext = "重新获取";
                    that.currentTime = 60;
                    that.disabled = false;
                }
            }, 1000);
        },
        onSubmit(form){
            let that=this;
            this.$refs[form].validate((valid) => {
                if (valid) {
                    for(let key in this.form) {
                        this.form[key] = (this.form[key] && typeof(this.form[key])=='string')?this.form[key].replace(/\s*/g,""):'';
                    }
                    this.$TsaWebTrace.post({
                        data: {
                            "eventId": 35023,
                            "logParam":{
                                'phone':that.form.phone,
                                'userName':that.form.legalName,
                                'idCard':that.form.idCard,
                                'code':that.form.code,
                            }
                        },
                    });
                    updateEntInfo(this.form).then(()=>{
                        sessionStorage.setItem("pesonalInfo", JSON.stringify(this.form));
                        this.$router.push({
                            path:'/userCenter/realName/legalFace',
                        })
                    })
                }
            })
        },
    },
};
</script>
<style lang="less" scoped>
.mianContent{
    position: relative;
    .back{
        position:absolute;
        right: 30px;
        top:-30px;
        font-size: 14px;
        cursor: pointer;
        &:hover{
            color:#10A0E9
        }
    }
}

.section {
    padding: 33px 0 41px;
}
.form {
    width: 675px;
    box-sizing: border-box;
    padding-top: 47px;
    padding-right: 150px;
    margin: 0 auto;
    dl{
        padding:0 30px;
        display: flex;
        align-items: center;
        font-size: 14px;
        margin-bottom: 20px;
        dd{
            margin-top: 5px;
        }
    }
    .yzm-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .yzm-item .el-form-item {
        width: 350px;
    }
    .yzm-item span {
        width: 148px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background: #fff;
        color: #3f7df7;
        cursor: pointer;
        border: 1px solid #3f7df7;
        font-size: 14px;
        margin-top: 3px;
        border-radius: 3px;
    }
    .yzm-item span:hover {
        background: #3f7df7;
        color: #fff;
    }
    .yzm-item span[disabled] {
        color: #fff;
        background: #bcbcbc;
        pointer-events: none;
        cursor: inherit;
        border-color: #bcbcbc;
    }
    .submit{
        span{
            display: inline-block;
            width: 130px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            border-radius: 5px;
            border:1px solid #10A0E9;
            cursor: pointer;
            background:#10A0E9;
            color: #fff;
            margin-bottom: 20px;
            margin-left: 140px;
            opacity: .7;
            &:hover{
                opacity: 1;
            }
        }
    }
}

</style>
